import { MessageCostSummary } from "@/models/MessageCost";
import ApiService from "@/services/api/api.service";
import { MessageCostSummarySchema } from "@/services/messageCost/messageCost.api.types";
import { MessageCostsEndpoints } from "@/services/messageCost/messageCost.endpoint";

export const MessageCostService = {
  async getMessageCostSummary(workspaceId: string): Promise<MessageCostSummary> {
    const { data } = await ApiService.fetchData<never, MessageCostSummarySchema>({
      url: MessageCostsEndpoints.GET_MESSAGE_COST_SUMMARY(workspaceId),
      method: "GET",
    });

    return new MessageCostSummary(data.pointLimit, data.usedPoints);
  },
};
